import { useCallback } from "react";
import { yupResolver } from "@hookform/resolvers/yup";

import Grid from "@mui/material/Grid";

import { useFormWithNotification } from "@covertree/hooks";
import { FormTextField } from "@covertree/ui";
import { FormSelectField } from "@covertree/ui/forms/FormSelectField";
import {
  LossType,
  TheftOrVandalism as TheftOfVandalismType,
} from "@api/operations.generated";
import { StepPath } from "@routing/paths";
import { useAppDispatch } from "@redux/hooks";
import { submitClaimDetails } from "@redux/slices";
import { useGetClaimDetailsForLossType } from "@hooks/useGetClaimDetailsForLossType";

import { TheftOrVandalismForm, validation } from "./form";
import { InjuredPersonsSection } from "../shared/InjuredPersonsSection";
import { ClaimsForm } from "../../ClaimsForm";

const claimTypeOptions = [
  {
    label: TheftOfVandalismType.Theft,
    value: TheftOfVandalismType.Theft,
  },
  {
    label: TheftOfVandalismType.Vandalism,
    value: TheftOfVandalismType.Vandalism,
  },
];

export function TheftOrVandalism() {
  const dispatch = useAppDispatch();

  const defaultValues = useGetClaimDetailsForLossType();

  const form = useFormWithNotification({
    mode: "all",
    reValidateMode: "onSubmit",
    defaultValues: { ...defaultValues },
    resolver: yupResolver(validation),
  });
  const { control } = form;

  const submit = useCallback((value: TheftOrVandalismForm) => {
    dispatch(
      submitClaimDetails({
        value,
        type: LossType.TheftOrVandalism,
      })
    );
  }, []);

  return (
    <ClaimsForm
      form={form}
      onSubmit={submit}
      navigateToStep={StepPath.UPLOAD_CLAIM_DOCUMENTS}
      dataTestId="theft-or-vandalism">
      <Grid item xs={12}>
        <FormSelectField
          id="claim-type"
          dataTestId="claim-type"
          name="claimType"
          options={claimTypeOptions}
          label="Claim Type"
          control={control}
        />
      </Grid>
      <Grid item xs={12}>
        <FormTextField
          id="claim-description"
          dataTestId="claim-description"
          name="claimDescription"
          rows={4}
          multiline
          label="Please describe what was stolen, how your items were damaged, or the extent of the vandalism. How do you think it happened?"
          control={control}
          InputProps={{
            sx: { padding: 0 },
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <InjuredPersonsSection />
      </Grid>
    </ClaimsForm>
  );
}
